import React, { useRef, useState } from 'react'
import { signUpUrl } from '../../../Container/App'
import Index from '../../../Assets/Images/Index'
import Slider from 'react-slick'
import Fade from 'react-reveal/Fade';
import { NavLink } from 'react-router-dom';

const themes = [
    {
        "id": 6,
        "theme_name": "WearDo",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_1766056210426yzlmf.png",
        "theme_preview_url": "weardo"
    },
    {
        "id": 11,
        "theme_name": "Boutique Biz",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_1763439891099mYevR.png",
        "theme_preview_url": "boutique-biz"
    },
    {
        "id": 13,
        "theme_name": "Drishtikon",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_1705926605383XT3KL.png",
        "theme_preview_url": "drishtikon"
    },
    {
        "id": 15,
        "theme_name": "Golden aura",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_1765262955568WL2Ms.png",
        "theme_preview_url": "golden-aura"
    },
    {
        "id": 7,
        "theme_name": "Neior",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_1763976539858pvRQk.png",
        "theme_preview_url": "neior"
    },
    {
        "id": 14,
        "theme_name": "Elixicare",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_1764654908500QmPxq.png",
        "theme_preview_url": "elixicare"
    },
    {
        "id": 17,
        "theme_name": "Powerpro supplements",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_17648504692683VBtB.png",
        "theme_preview_url": "powerpro-supplements"
    },
    {
        "id": 23,
        "theme_name": "Pure essence",
        "image": "https://cdn.forgetaday.com/s/files/template-image/templates_1765971394781V57lH.png",
        "theme_preview_url": "pureessence"
    }
]
const onePlatform = [
    {
        img: Index.featureIcon1,
        title: "Fully Customized Stores",
        content: "We make it possible for you to get industry-specific themes to create a digital store. You can customize your digital store whenever you need as the market trend changes."
    },
    {
        img: Index.featureIcon2,
        title: "Multi Gateway Payment",
        content: "Flexible payment modes enable you to engage more customers with your brand without any barriers. Integrate the best possible payment modes to meet your needs."
    },
    {
        img: Index.featureIcon3,
        title: "24*5 Tech Support",
        content: "We don't make you wait to get your queries resolved. We work around the clock to fulfill your ecommerce service requirements. You can reach us anytime for technical assistance."
    },
    {
        img: Index.featureIcon4,
        title: "Sales Escalation",
        content: "An aesthetically designed and perfectly optimized store helps you to be easily visible on the web and attract heavy traffic which leads to high conversion rates."
    },
    {
        img: Index.featureIcon5,
        title: "Full Maintenance ",
        content: "Our job is not completed just after launching your digital store. We can offer you complete maintenance assistance for the flawless online working of your business store."
    },
    {
        img: Index.featureIcon6,
        title: "Excellent Teams",
        content: "We have top-seeded industry experts with us who are committed to delivering on-time services to our clients without fail. Our experts will help you grow in the digital landscape."
    },
]

const PrevArrow = ({ onClick }) => {
    return (
        <button className="quote-arrow quote-prev" onClick={onClick} type="button" aria-label="Previous"><img src={Index.prevArrow} alt="" /></button>
    );
};

const NextArrow = ({ onClick }) => {
    return (
        <button className="quote-arrow quote-next" onClick={onClick} type="button" aria-label="Next"><img src={Index.nextArrow} alt="" /></button>
    );
};

var settings = {
    arrows: true,
    centerMode: true,
    centerPadding: '400px',
    slidesToShow: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                centerPadding: '250px'
            }
        },
        {
            breakpoint: 1299,
            settings: {
                centerPadding: '180px'
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerPadding: '120px'
            }
        },
        {
            breakpoint: 575,
            settings: {
                centerPadding: '0px'
            }
        }
    ]
};

export default function Home() {
    const [error, seterror] = useState({
        show: false,
        msg: ""
    })
    const [email, setEmail] = useState("")
    const sectionRef = useRef(null);

    const handleScroll = () => {
        sectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };


    const handleEmail = (e) => {
        setEmail(e.target.value)
    }
    const submitEmail = (e) => {
        e.preventDefault();
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (email === "") {
            seterror({
                show: true,
                msg: "Please enter your email"
            })
        } else if (email !== "" && !pattern.test(email)) {
            seterror({
                show: true,
                msg: "Please enter valid email"
            })
        } else {
            seterror({
                show: false,
                msg: ""
            })
            window.open(`${signUpUrl}?email=${email}`, "_self")
        }
    }
    return (
        <main>
            <section className="banner commonPY" style={{ backgroundImage: `url(${Index.headerbannerNew})` }}>
                <div className="container z-index">
                    <div className="row">
                        <div className="col-md-8 col-lg-6">
                            <Fade up>
                                <div className="bannerContent">
                                    <div className="subTitle">
                                        <h5>India's Top</h5>
                                    </div>
                                    <h1>Ecommerce Solution Provider</h1>
                                    <p>We offer you high-quality and low-cost Ecommerce services without any hassle. Create digital store with no code.</p>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="bannerForm">
                                    <form onSubmit={submitEmail}>
                                        <div className="row">
                                            <div className="col-12 form-group"><h4>Get Started for Free</h4></div>
                                            <div className="col-lg-7 form-group">
                                                <input type="email" className="form-control" placeholder="Email Address" onChange={handleEmail} />
                                            </div>
                                            <div className="col-lg-5 form-group">
                                                <button className="commonButton primary" type="submit">Start Free Trial</button>
                                            </div>
                                        </div>
                                    </form>
                                    {error.show ?
                                        <p style={{ color: "#ff0000" }}><small>{error.msg}</small></p> : null
                                    }
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fewClickSctn commonPY">
                <div className="container">
                    <Fade up>
                        <div className="headingText mb-5">
                            <h2>Make an Impressive Digital Identity<br /> with Fewer Efforts</h2>
                        </div>
                    </Fade>

                    <Fade up>
                        <div className="fewClickImage">
                            <img src={Index.featureImgNew} alt="" />
                        </div>
                        <div className="buttonOuter">
                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                        </div>
                    </Fade>
                </div>
            </section>

            <section className="whyShopyxa gradientBg commonPY">
                <div className="container">
                    <div className="headingText mb-5">
                        <div className="subTitle">
                            <h5>Why Shopyxa</h5>
                        </div>
                        <h2>Build Your Customer Base Nationwide Quickly</h2>
                    </div>
                    <div className="shopyxaFeatures">
                        <div className="row">
                            <Fade up>
                                {onePlatform.map((item, index) => {
                                    return (
                                        <div className="col-md-6 col-lg-4" key={index}>
                                            <div className="featuresGrid">
                                                <div className="featuresIcon"><img src={item.img} alt="" /></div>
                                                <h4>{item.title}</h4>
                                                <p>{item.content}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </Fade>
                        </div>
                    </div>
                </div>
            </section>

            <section className="commonPY theme_home">
                <div className='container'>
                    <Fade up>
                        <div className="headingText mb-5">
                            <h2>Kickstart your business with <span>Exclusive themes</span></h2>
                        </div>
                    </Fade>
                </div>

                <Fade up>
                    <div className='theme_home_img'>
                        <img src={Index.projectslide} alt="" className='w-100' />
                    </div>
                </Fade>

                <Fade up>
                    <div className='text-center mt-4 mt-md-5'>
                        <button className="commonButton primary" onClick={handleScroll}>Explore Themes</button>
                    </div>
                </Fade>
            </section>
            <section className="contentBlock commonPY">
                <div className="container">
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6">
                                    <div className="contentBlockImage">
                                        <img src={Index.contentBlock1} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6">
                                    <div className="contentBlockContent">
                                        <h3>A Successful Digital Store</h3>
                                        <p>Take your brand to the next level with extraordinary inventory management, order tracking, and real-time data insights. Our hands-on experience with the latest tools gives you unique recognition among your rivals.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6">
                                    <div className="contentBlockImage">
                                        <img src={Index.contentBlock2} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6">
                                    <div className="contentBlockContent">
                                        <h3>Easy to Manage & Sell</h3>
                                        <p>Manage everything from inventory to pricing and other features from a single dashboard. Your products are ready to be sold handily in less time.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </section>

            <section className="commonPY gradientBg " ref={sectionRef}>
                <div className="container">
                    <Fade up>
                        <div className="headingText mb-5">
                            <h2>Real <span>Shopyxa</span> results</h2>
                        </div>
                    </Fade>
                    <div className="themesSlider">
                        <div className='row g-3 g-md-5'>
                            {themes.map((item, index) => {
                                return (
                                    <Fade up key={index} delay={index * 100}>
                                        <div className='col-md-4 col-6'>
                                            <a href={`https://${item?.theme_preview_url}.appshopyxa.com`} target='_blank' rel="noopener noreferrer" className='themesSlider_item'>
                                                <div className='themesSlider_img'>
                                                    <img src={item?.image} alt="" />
                                                </div>
                                                <h4>{item?.theme_name}</h4>
                                            </a>
                                        </div>
                                    </Fade>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>
            <section className="quote commonPY">
                <div className="container">
                    <Fade up>
                        <div className="headingText mb-5">
                            <h2>Meet the merchants who love <span>Shopyxa</span></h2>
                        </div>
                    </Fade>
                </div>
                <div className="quoteSlider">
                    <Slider {...settings}>
                        <div className="item">
                            <div className="quoteSlider__quote">
                                <div className="quoteIcon"><img src={Index.quoteIcon} alt="" /></div>
                                <div className="quoteContent">
                                    <div className="avatar"><img src={Index.kavitaKausal} alt="" /></div>
                                    <h4>Kavita Kausal</h4>
                                    <h6>CEO</h6>
                                    <p>I've found Shopyxa to be the best alternative for an e-commerce store-building platform. My brand is recognized nationwide now! All thanks to Shopyxa, which has the best potential for displaying my products online at a low cost.</p>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="quoteSlider__quote">
                                <div className="quoteIcon"><img src={Index.quoteIcon} alt="" /></div>
                                <div className="quoteContent">
                                    <div className="avatar"><img src={Index.pawasMahajan} alt="" /></div>
                                    <h4>Pawas Mahajan</h4>
                                    <h6>CEO</h6>
                                    <p>I started with their 15 days free trial, was impressed with their Shopyxa platform, and decided to maintain a long-term relationship with them to enjoy their services and improve my store.</p>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="quoteSlider__quote">
                                <div className="quoteIcon"><img src={Index.quoteIcon} alt="" /></div>
                                <div className="quoteContent">
                                    <div className="avatar"><img src={Index.judieLastina} alt="" /></div>
                                    <h4>Judie Lastina</h4>
                                    <h6>CEO</h6>
                                    <p>With my Shopyxa store, I am able to reach my target customers across all of India. I can get deep insights into the data and observe my audience's behavior, which helps me grow further. You should definitely try this platform if you are looking for high-class services on a low budget.</p>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
                {/* <div className="sliderButtons">
                    <PrevArrow />
                    <NextArrow />
                </div> */}
            </section>

            <section className="cta commonPB">
                <div className="container">
                    <Fade up>
                        <div className="ctaInner">
                            <div className="headingText white"><h2>Supporting Tomorrow's Entrepreneurs Today</h2></div>
                            <div className="buttonOuter">
                                <a className="commonButton outline" href={signUpUrl}>15 Days Free Trial</a>
                            </div>
                        </div>
                    </Fade>
                </div>
            </section>
        </main>
    )
}
